import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { MapContainer } from '@/features/map/components/mapContainer'
import ApiSidebar from '@/features/mapFilters/components/apiSidebar'
import SidebarMobile from '@/features/mapFilters/components/sidebarMobile'
import { useIsMobileDeviceWidth } from '@/hooks/useIsMobileDeviceWidth'
import { mapDeploymentsOptions } from '../store/mapDeployments/fetchMapDeployments'

export const Route = createFileRoute('/xyzenablement')({
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(mapDeploymentsOptions),
	component: RouteComponent,
	head: () => ({
		// title: 'My App',
		meta: [
			{
				title: 'Enablement',
			},
		],
		// scripts: [
		// 	{
		// 		src: 'https://www.google-analytics.com/analytics.js',
		// 	},
		// ],
	}),
})

function RouteComponent() {
	const { isLoading, data } = useSuspenseQuery(mapDeploymentsOptions)
	const isMobile = useIsMobileDeviceWidth()

	if (isLoading) return <div>Loading...</div>
	return (
		<div className="grid md:grid-cols-(--grid-template-columns-map-layout-large) relative mx-auto min-h-[var(--total-height)] w-full">
			{isMobile && <SidebarMobile />}
			{data && !isMobile && <ApiSidebar />}
			<MapContainer />
			{/* {data && <pre>{JSON.stringify(data,null,2)}</pre>} */}
		</div>
	)
}
